import api from '@/api'

const actions = {
  authorizeTypetalk() {
    location.href =
      'https://typetalk.com/oauth2/authorize?client_id=' +
      AppConfig.typetalkClientId +
      '&scope=topic.post&response_type=code&redirect_uri=' +
      AppConfig.url +
      '/?page=student/Achievements'
  },
  async getNewToken({ commit }, code) {
    try {
      await api.typetalk.getNewToken(code)
      return Promise.resolve()
    } catch (err) {
      return Promise.reject(err)
    }
  },
  async checkIsTypetalkAuthenticated({ commit }) {
    try {
      await api.typetalk.checkAuth()
      return Promise.resolve()
    } catch (err) {
      return Promise.reject(err)
    }
  }
}

export default {
  namespaced: true,
  actions
}
